module.exports = __webpack_public_path__ + "img/protester2.359256be.png";